import React from "react";
import { TrustpilotCategoryRanking } from "domain/reviews/types";
import { getIntlLocale, useLocale, useTranslations } from "lib/i18n";

const RankingBadge: React.FC<{ ranking: TrustpilotCategoryRanking }> = ({
  ranking,
}) => {
  const t = useTranslations("common");
  const locale = useLocale();
  const { rank, total, categorySlug, url } = ranking;
  const category = t(`trustpilot.categories.${categorySlug}`);
  const totalLabel = total.toLocaleString(getIntlLocale(locale));
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t("trustpilot.rankAria", {
        rank,
        total: totalLabel,
        category,
      })}
      css={`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 24px 16px;
        border-radius: 12px;
        background-color: #ffffff;
        border: 1px solid #e5e7eb;
        text-align: center;
        text-decoration: none;
        color: inherit;
        transition: border-color 0.15s ease, box-shadow 0.15s ease;
        :hover,
        :focus-visible {
          border-color: #00b67a;
          box-shadow: 0 4px 12px rgba(0, 182, 122, 0.15);
        }
      `}
    >
      <div
        css={`
          font-size: 32px;
          font-weight: 700;
          line-height: 1;
          color: #00b67a;
        `}
      >
        #{rank}
      </div>
      <div
        css={`
          margin-top: 4px;
          font-size: 12px;
          color: #6b7280;
        `}
      >
        {t("trustpilot.rankOf", { total: totalLabel })}
      </div>
      <div
        css={`
          margin-top: 12px;
          font-size: 14px;
          font-weight: 600;
          line-height: 1.35;
          color: #111827;
        `}
      >
        {category}
      </div>
    </a>
  );
};

export default RankingBadge;
